import Immutable from 'immutable';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// components
import Appointment from './_Appointment';
import { PanelBody } from '../../shared/_panel';

class IndexRow extends React.Component {
  static propTypes = {
    appointment:  PropTypes.instanceOf(Immutable.Map),
    appointments: PropTypes.instanceOf(Immutable.Map),
    date:         PropTypes.instanceOf(moment)
  }

  render() {
    const { date } = this.props;

    return (
      <div>
        <div className='rep-calendar-index__list__header'>
          { date.format('MMM D, YYYY') }
        </div>
        <PanelBody className='rep-calendar-index__list__container'>
          { this._renderAppointments() }
        </PanelBody>
      </div>
    );
  }

  // private

  _renderAppointments() {
    const { appointments } = this.props;

    const result    = (this.props.appointment || Immutable.Map()).get('result') || Immutable.List();
    const elements  = [];

    const items = appointments.sort((a, b) => {
      const segmentA = a.get('segmentNumber');
      const segmentB = b.get('segmentNumber');

      let value = 0;

      if (segmentA < segmentB) {
        value = -1;
      } else if (segmentA > segmentB) {
        value = 1;
      }

      return value;
    });

    items.forEach((item) => {
      if (result.includes(item.get('id'))) {
        elements.push(
          <Appointment appointment={ item } key={ item.get('id') } />
        );
      }
    });

    return elements;
  }
}

const mapStateToProps = (state) => {
  return {
    appointment: state.get('appointment')
  };
};

export default connect(mapStateToProps)(IndexRow);



// WEBPACK FOOTER //
// ./app/components/reps/calendar/_IndexRow.jsx